const GENERIC_HTTP_ERROR_PATTERN = /^HTTP error!\s*status:\s*\d+$/i;

function extractErrorBodyMessage(errorBody) {
    if (typeof errorBody === 'string') {
        const trimmedBody = errorBody.trim();
        if (!trimmedBody) {
            return null;
        }

        try {
            const parsed = JSON.parse(trimmedBody);
            return typeof parsed?.message === 'string' && parsed.message.trim().length > 0
                ? parsed.message.trim()
                : trimmedBody;
        } catch (_) {
            return trimmedBody;
        }
    }

    if (errorBody && typeof errorBody === 'object' && typeof errorBody.message === 'string') {
        const trimmedMessage = errorBody.message.trim();
        return trimmedMessage.length > 0 ? trimmedMessage : null;
    }

    return null;
}

export function extractApiErrorMessage(error, fallback) {
    const bodyMessage = extractErrorBodyMessage(error?.body)
        || (typeof error?.response?.data?.message === 'string' ? error.response.data.message.trim() : '');
    if (bodyMessage) {
        return bodyMessage;
    }

    const directMessage = typeof error?.message === 'string' ? error.message.trim() : '';
    if (directMessage && !GENERIC_HTTP_ERROR_PATTERN.test(directMessage)) {
        return directMessage;
    }

    return fallback;
}
